module.exports = __webpack_public_path__ + "static/showcase-img-f7d7446e1a1a30553d36393ce66d136c.png";